import React from "react";
import { useNavigate } from "react-router-dom";

import Breadcrumbs from "@mui/material/Breadcrumbs";
import Chip from "@mui/material/Chip";
import HomeIcon from "@mui/icons-material/Home";
import { styled } from "@mui/material/styles";
import { useAppSelector, useAppDispatch } from "../redux/hooks";
const StyledBreadcrumb = styled(Chip)(({ theme }) => {
  const backgroundColor =
    theme.palette.mode === "light"
      ? theme.palette.grey[100]
      : theme.palette.grey[800];
  return {
    backgroundColor,
    height: theme.spacing(3),
    color: theme.palette.text.primary,
    fontWeight: theme.typography.fontWeightRegular,
  };
}) as typeof Chip;

export const BreadcrumbBar = () => {
  const dispatch = useAppDispatch();
  const nav = useNavigate();
  const goToDashboard = () => {

    setTimeout(() => {
      nav("/");
    }, 0);
  };

  const pathnames = window.location.pathname.split("/").filter((x) => x);
  if (pathnames.length == 2 && pathnames[1] == "index.html") {
    pathnames.pop();
  }
  if (pathnames.length == 1 && pathnames[0].toLowerCase() == "nvh") {
    pathnames.pop();
  }

  console.log(window.location.pathname);
  const breadcrumbNameMap: { [key: string]: string } = {
    "/global/dashboard": " Global/Dashboard",
    "/main/dashboard": "US / Dashboard",
    "/main/appraisal-form/new": "US / Dashboard / New Form",
    "/main/appraisal-form/edit": "US / Dashboard / Edit Form",
    "/main/appraisal-form/view": "US / Dashboard / View Form",
    "/main/debt-liability/new": "US / Dashboard / New DL Form",
    "/main/debt-liability/edit": "US / Dashboard / Edit DL Form",
    "/main/debt-liability/view": "US / Dashboard / View DL Form",
    "/userrolemap/list": "User Role/Dashboard",
    "/main/to-dos": "US/TO-Dos",
    "/userrolemap/new": "User Role/Dashboard/New Form",
    "/userrolemap/edit": "User Role/Dashboard/Edit Form",
    "/userrolemap/view": "User Role/Dashboard/View Form",
    "/investmentmaster/list": "Investment/Dashboard",
    "/investmentmaster/edit": "Investment/Dashboard/Edit Form",
    "/investmentmaster/view": "Investment/Dashboard/View Form",
    "/investmentmaster/new": "Investment/Dashboard/New Form",
    "/appraiserfirm/list": "Appraiser/Dashboard",
    "/appraiserfirm/edit": "Appraiser/Dashboard/Edit Form",
    "/appraiserfirm/view": "Appraiser/Dashboard/View Form",
    "/appraiserfirm/new": "Appraiser/Dashboard/New Form",
    "/funds/list": "Funds/Dashboard",
    "/funds/edit": "Funds/Dashboard/Edit Form",
    "/funds/view": "Funds/Dashboard/View Form",
    "/funds/new": "Funds/Dashboard/New Form",
    "/todo/list": "Todo/Dashboard",
    "/todo/edit": "Todo/Dashboard/Edit Form",
    "/todo/view": "Todo/Dashboard/View Form",
    "/todo/new": "Todo/Dashboard/New Form",
    "/fundconfig/list": "Fund Configuration/Dashboard",
    "/fundconfig/edit": "Fund Configuration/Dashboard/Edit Form",
    "/fundconfig/view": "Fund Configuration/Dashboard/View Form",
    "/fundconfig/new": "Fund Configuration/Dashboard/New Form",
    "/role/list": "Role/Dashboard",
    "/role/edit": "Role/Dashboard/Edit Form",
    "/role/view": "Role/Dashboard/View Form",
    "/role/new": "Role/Dashboard/New Form",
    "/global/global-equity/edit": "Global/Global-Equity/Dashboard/Edit Form",
    "/global/global-equity/view": "Global/Global-Equity/Dashboard/View Form",
    "/global/global-equity/new": "Global/Global-Equity/Dashboard/New Form",
    "/unauthorized": "Unauthorized",
  };

  const id = pathnames.slice(-1)[0];
  let basePath = pathnames[0];
  if (basePath === "main") {
    basePath = pathnames[0] + "/" + pathnames[1];
  }

  switch (basePath) {
    case "investmentmaster":
      breadcrumbNameMap["/investmentmaster/view/" + id] =
        "Investment / Dashboard / View Form";
      breadcrumbNameMap["/investmentmaster/edit/" + id] =
        "Investment / Dashboard / Edit Form";
      break;
    case "userrolemap":
      breadcrumbNameMap["/userrolemap/view/" + id] =
        "User Role / Dashboard / View Form";
      breadcrumbNameMap["/userrolemap/edit/" + id] =
        "User Role / Dashboard / Edit Form";
      break;
    case "main/appraisal-form":
      breadcrumbNameMap["/main/appraisal-form/edit/" + id] =
        "US / Dashboard / Edit Form";
      breadcrumbNameMap["/main/appraisal-form/view/" + id] =
        "US / Dashboard / View Form";
      break;
    case "main/debt-liability":
      breadcrumbNameMap["/main/debt-liability/edit/" + id] =
        "US / Dashboard / Edit Form";
      breadcrumbNameMap["/main/debt-liability/view/" + id] =
        "US / Dashboard / View Form";
      break;
    case "funds":
      breadcrumbNameMap["/funds/view/" + id] =
        "Funds / Dashboard / View Form";
      breadcrumbNameMap["/funds/edit/" + id] =
        "Funds / Dashboard / Edit Form";
      break;
    case "fundconfig":
      breadcrumbNameMap["/fundconfig/view/" + id] =
        "Fund Configuration / Dashboard / View Form";
      breadcrumbNameMap["/fundconfig/edit/" + id] =
        "Fund Configuration/ Dashboard / Edit Form";
      break;
    case "role":
      breadcrumbNameMap["/role/view/" + id] =
        "Role / Dashboard / View Form";
      breadcrumbNameMap["/role/edit/" + id] =
        "Role/ Dashboard / Edit Form";
      break;

    case "appraiserfirm":
      breadcrumbNameMap["/appraiserfirm/view/" + id] =
        "Appraiser Firm / Dashboard / View Form";
      breadcrumbNameMap["/appraiserfirm/edit/" + id] =
        "Appraiser Firm / Dashboard / Edit Form";
      breadcrumbNameMap["/appraiserfirm/new"] =
        "Appraiser Firm / Dashboard / New Form";
      breadcrumbNameMap["/appraiserfirm/list"] =
        "Appraiser Firm / Dashboard";
      break;
    case "fundconfig":
      breadcrumbNameMap["/fundconfig/view/" + id] =
        "Fund Configuration / Dashboard / View Form";
      breadcrumbNameMap["/fundconfig/edit/" + id] =
        "Fund Configuration / Dashboard / Edit Form";
      breadcrumbNameMap["/fundconfig/new"] =
        "Fund Configuration / Dashboard / New Form";
      breadcrumbNameMap["/fundconfig/list"] =
        "Fund Configuration / Dashboard";
      break;
    case "global":
      breadcrumbNameMap["/global/global-equity/view/" + id] =
        "Global / Dashboard / View Form";
      breadcrumbNameMap["/global/global-equity/edit/" + id] =
        "Global / Dashboard / Edit Form";
      breadcrumbNameMap["/global/global-equity/new"] =
        "Global / Dashboard / New Form";
      breadcrumbNameMap["/global/dashboard"] =
        "Global / Dashboard ";
      break;
    case "main":
      breadcrumbNameMap["/main/view/" + id] =
        "Main / Dashboard / View Form";
      breadcrumbNameMap["/main/edit/" + id] =
        "Main / Dashboard / Edit Form";
      breadcrumbNameMap["/main/new"] =
        "Main / Dashboard / New Form";
      breadcrumbNameMap["/main/dashboard"] =
        "Main / Dashboard ";
      break;

  }


  console.log(breadcrumbNameMap);

  const handleNavigate = (value: any, n: string) => {
    if (!n.includes("Form")) {
      var url = value.split('/').slice(0, 3).join('/') + '/';
      switch (url) {
        case "/investmentmaster/new/":
        case "/investmentmaster/edit/":
        case "/investmentmaster/view/":
        case "/investmentmaster/list/":
          nav("/investmentmaster/list");
          break;
        case "/userrolemap/new/":
        case "/userrolemap/edit/":
        case "/userrolemap/view/":
        case "/userrolemap/list/":
          nav("/userrolemap/list");
          break;
        case "/funds/new/":
        case "/funds/edit/":
        case "/funds/view/":
        case "/funds/list/":
          nav("/funds/list");
          break;
        case "/fundconfig/new/":
        case "/fundconfig/edit/":
        case "/fundconfig/view/":
        case "/fundconfig/list/":
          nav("/fundconfig/list");
          break;
        case "/role/new/":
        case "/role/edit/":
        case "/role/view/":
        case "/role/list/":
          nav("/role/list");
          break;
        case "/global/global-equity/":
        case "/global/global-equity/edit/":
        case "/global/global-equity/view/":
        case "/global/global-equity/list/":
          nav("/global/dashboard");
          break;

        case "/main/appraisal-form/":
        case "/main/debt-liability/":
          nav("/main/dashboard");
          break;

        case "/appraiserfirm/new/":
        case "/appraiserfirm/edit/":
        case "/appraiserfirm/view/":
        case "/appraiserfirm/list/":
          nav("/appraiserfirm/list");
          break;

        default:
          break;
      }

    }
  }

  return (
    <div role="presentation" className="mt-05" >
      <Breadcrumbs aria-label="breadcrumb" className="breadcrumb">
        <StyledBreadcrumb
          label="NVH"
          onClick={() => goToDashboard()}
          icon={<HomeIcon fontSize="small" className="custom-class" />}
        />
        {pathnames.map((name, index) => {
          console.log(name);

          if (index + 1 == pathnames.length) {
            if (pathnames.length == 2 && pathnames[1] == "index.html") {
              pathnames.pop();
            }
            const goTo = `/${pathnames.slice(0, index + 1).join("/")}`;
            const mappedKey = Object.keys(breadcrumbNameMap).filter((key) =>
              goTo.includes(key)
            );
            console.log(goTo);
            console.log(mappedKey);
            const mappedValue = breadcrumbNameMap[goTo];
            console.log(mappedValue);
            return mappedValue
              .split("/")
              .filter((x) => x)
              .map((n, i) => <StyledBreadcrumb label={n} onClick={() => handleNavigate(goTo, n)} component="a" />);
          }
        })}
      </Breadcrumbs>
    </div>
  );
};


// import * as React from "react";
// import Typography from "@mui/material/Typography";
// import Breadcrumbs from "@mui/material/Breadcrumbs";
// import Link from "@mui/material/Link";
// import HomeIcon from "@mui/icons-material/Home";
// import GridViewIcon from "@mui/icons-material/GridView";

// function handleClick(event: React.MouseEvent<HTMLDivElement, MouseEvent>) {
//   event.preventDefault();
//   console.info("You clicked a breadcrumb.");
// }

// export const BreadcrumbBar = () => {
//   return (
//     <div role="presentation" className="mt-05" onClick={handleClick}>
//       <Breadcrumbs aria-label="breadcrumb" className="breadcrumb">
//         <Link
//           underline="hover"
//           sx={{ display: "flex", alignItems: "center" }}
//           color="inherit"
//           href="/"
//         >
//           <HomeIcon sx={{ mr: 0.5 }} fontSize="inherit" />
//           Home
//         </Link>
//         <Typography
//           sx={{ display: "flex", alignItems: "center" }}
//           color="text.primary"
//         >
//           <GridViewIcon sx={{ mr: 0.5 }} fontSize="inherit" />
//           Dashboard
//         </Typography>
//       </Breadcrumbs>
//     </div>
//   );
// };
